import { call, put, takeEvery } from 'redux-saga/effects';
import { SalesAdminActionKeys, SaveSaRegion } from '..';
import { IRegion, lookupActionCreators } from '../../lookups';
import { uiActionCreators } from '../../ui';
import * as api from '../salesAdminApi';

function* saveSaRegionSaga(action: SaveSaRegion) {
  yield put(uiActionCreators.showSpinnerDialog());
  try {
    const regions: IRegion[] =
      action.payload.regionId > 0
        ? yield call(api.UpdateRegion, action.payload)
        : yield call(api.SaveRegion, action.payload);

    yield put(lookupActionCreators.setLookups({ partial: true, payload: { regions } }));
  } catch {
    //
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveSaRegion() {
  yield takeEvery(SalesAdminActionKeys.SAVE_SA_REGION, saveSaRegionSaga);
}
